import React from "react";
import moment from "moment";
import { Link, Redirect } from "react-router-dom";

import { getData } from "../../../services/index";
import "antd/dist/antd.css";
import { message, Menu, Button } from "antd";

import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
import RouteGoogleMap from "../../RouteGoogleMap";

class Index extends React.Component {
  static contextTypes = {
    router: () => null,
  };
  constructor(props) {
    super(props);
    this.state = {
      locationLoading: true,
      viewLoading: true,
      user_id: 0,
      feedback: "",
      is_open: 0,
      tag: "",
      route_list: [],
      path: [],
      selected_child: [],
      data_list: [],
      is_child_selected: 0,
      is_trip_started: 0,
      route_name: "",
    };
  }

  componentWillMount() {
    document.querySelector(".loader-wrapper").style = "display: none";
    setTimeout(() => {
      document.querySelector(".loader-wrapper").style = "display: none";
    }, 500);
    if (!localStorage.getItem("schoolData")) {
      localStorage.setItem("schoolData", "");
      localStorage.clear();
      window.location.href = "/login";
    } else {
		this.setState({
            route_id: this.props.match.params.id,
            route_type: this.props.match.params.name,
        });
		this.checkData();
    }
  }

  checkData() {
    if (localStorage.getItem("schoolData")) {
      var route_id = this.props.match.params.id;
      var route_type = this.props.match.params.name;
      var route_date = this.props.match.params.date;
      var app = { route_id: route_id,route_type:route_type,route_date:route_date };
      getData("Transport/old_route_details", app).then((result) => {
        let responseJson = result;
        if (responseJson.data) {
          if (result["status"] == 200) {
            this.setState({
              data_list: result["data"],
              route_name: result["data"][0]["name"],
              path: result["data"][0]["path"],
              route_list: result["data"][0]["stop_array"],
              is_open: result["data"][0]["step_no"],
              tag: result["data"][0]["tag"],
              selected_child: [],
              viewLoading: false,
            });
          } else {
            this.setState({
              route_name: "",
              path: [],
              route_list: [],
              selected_child: [],
              viewLoading: false,
            });
          }
        }
      });
    }


  }

  showAction = (index) => {
    if (this.state.selected_child.length == 0) {
      if (index == this.state.is_open) {
        this.setState({ is_open: -1 });
      } else {
        this.setState({ is_open: index });
      }
    } else {
      if (this.state.is_trip_started < 2) {
        alert("Please Pick Up Selected Children");
      } else {
        this.setState({ is_open: index });
      }
    }
  };

  isSelectedChild = (student_id, is_travel) => {
		if (is_travel > 0) {
		  return true;
		} else {
			var array = this.state.selected_child;
			const index = array.indexOf(student_id);
			if (index > -1) {
				return true;
			} else {
				return false;
			}
		}
    };

  reverseLookup = (lat, lng) => {};

  render() {
    return (
      <>
        <div class="row bred">
		<div class="col-md-12">
		<div class="card">
		<div class="card-body">
			<h4 class="page-title">
				<i class="mdi mdi-apple-keyboard-command title_icon"></i>Details Ongoing Route History

				<div class="breadcrumb-wrapper">
					<ol class="breadcrumb">
						<li class="breadcrumb-item">
							<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
							<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
							</a>
						</li>
						<li class="breadcrumb-item"> <a href={`${process.env.PUBLIC_URL}/transport-setup/ongoing-route-history`} class="router-link-active" target="_self">Ongoing Route History</a> </li>
						<li class="breadcrumb-item"> Details </li>
					</ol>
				</div>
			</h4>
		</div>
		</div>
		</div>
	</div>

        <div class="row">
          <div class="col-lg-12 mb-3">
            <div class="card">
              <div class="card-body">
                <div class="row" style={{'align-items': 'baseline'}}>
				    <div class="col-lg-5 col-md-5 col-xs-12">
						{this.state.data_list.map((list, index) => (
						<>
						<div class="col-md-12">
							<h5>Date : <b>{list.route_date}</b></h5>
						</div>
						<div class="col-md-12 mt-20">
							<h5>Route Name : <b>{list.name}</b></h5>
						</div>
						<div class="col-md-12 mt-20">
							<h5>Route Type : <b>{list.tag}</b></h5>
						</div>
						<div class="col-md-12 mt-20">
							<h5>Bus : <b>{list.bus_name} - {list.bus_no}</b></h5>
						</div>
						<div class="col-md-12 mt-20">
							<h5>Driver : <b>{list.driver_name} - {list.driver_mob}</b></h5>
						</div>
						</>
						))}
					</div>
                  <div class="col-lg-7 col-md-7 col-xs-12">
                    <div className="innerContainer">
                      {this.state.route_list.map((item, index) => (
                        <>
                          {(() => {
                            if (item.type == "start") {
                              return (
                                <>
                                  <div
                                    className="stepBox"
                                    onPress={() => this.showAction(index)}
                                  >
                                    <div className="stepIconView">
                                      <img
                                        src="/assets/images/process1.png"
                                        className="activeCircle"
                                      />
                                      <div className="verticalLine">
                                        <img
                                          src="/assets/images/line.png"
                                          className="svgLine"
                                        />
                                      </div>
                                    </div>
                                    <div
                                      className="step-right"
                                      onPress={() => this.showAction(index)}
                                    >
                                      <div className="routeDetails">
                                        <div className="circle">
                                          <h1 className="routeNumber">1</h1>
                                        </div>
                                        <div className="routeView">
                                          <h1 className="routeName">Start</h1>
                                        </div>
                                      </div>
                                      <div className="blankHeight"></div>
                                    </div>
                                  </div>
                                  <div
                                    className="stepBox"
                                    collapsed={
                                      index == this.state.is_open ? false : true
                                    }
                                  >
                                    <div className="verticalView">
                                      <div className="verticalLine">
                                        <img
                                          src="/assets/images/line.png"
                                          className="svgLine"
                                        />
                                      </div>
                                    </div>
                                    <div className="route-right">
                                      {item.is_arrive > 0 ? (
                                        <div className="startedView">
                                          <h1 className="startedText">
                                            Trip started! at {item.pickup_time}
                                          </h1>
                                        </div>
                                      ) : (
                                        <div className="route-btn">
                                          <h1 className="btnText">
                                            Not Started Yet
                                          </h1>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </>
                              );
                            } else if (item.type == "pickup") {
                              return (
                                <>
                                  <div
                                    className="stepBox"
                                    onPress={() => this.showAction(index)}
                                  >
                                    <div className="stepIconView">
                                      {this.state.is_open == index ? (
                                        <>
                                          <div className="circleBox">
                                            <img
                                              src="/assets/images/bus-stop.png"
                                              className="circleBoxImg"
                                            />
                                          </div>
                                          <div className="verticalLine">
                                            <img
                                              src="/assets/images/line.png"
                                              className="svgLine"
                                            />
                                          </div>
                                        </>
                                      ) : (
                                        <img
                                          src="/assets/images/process1.png"
                                          className="activeCircle"
                                        />
                                      )}
                                      <div className="verticalLine">
                                        <img
                                          src="/assets/images/line.png"
                                          className="svgLine"
                                        />
                                      </div>
                                    </div>

                                    <div onPress={() => this.showAction(index)}>
                                      <div className="routeDetails">
                                        <div className="circle">
                                          <h1 className="routeNumber">
                                            {index + 1}
                                          </h1>
                                        </div>
                                        <div className="routeView">
                                          <h1 className="routeName">
                                            {item.Stop}
                                          </h1>
                                        </div>
                                      </div>
                                      <div className="blankHeight"></div>
                                    </div>
                                  </div>

                                  <div
                                    className="stepBox"
                                    collapsed={
                                      index == this.state.is_open ? false : true
                                    }
                                  >
                                    <div className="verticalView">
                                      <div className="verticalLine">
                                        <img
                                          src="/assets/images/line.png"
                                          className="svgLine"
                                        />
                                      </div>
                                    </div>
                                    <div className="route-right">
                                      <div className="mainView">
                                        <h1 className="scheduledText">
                                          Scheduled Time: {item.pickup_time}
                                        </h1>
                                        <h1 className="arrivalText">
                                          Arrival Time: {item.arrive_time}
                                        </h1>
                                      </div>

                                      <div className="childProfile">
                                        {item.student_array.map(
                                          (student, index) => (
                                            <div className="childList">
                                              <div className="imgBox">
                                                <img
                                                  src={student.image}
                                                  className="childImg"
                                                />
                                              </div>
                                              <div className="infoBox">
                                                <h1 className="childName">
                                                  {student.name}
                                                </h1>
                                                <h1 className="className">
                                                  {student.class}
                                                </h1>
                                              </div>
                                              <div className="checkBox">
                                                {this.isSelectedChild(
                                                  student.id,
                                                  student.is_travel
                                                ) ? (
                                                  <img
                                                    src="/assets/images/check.png"
                                                    className="checkImg"
                                                  />
                                                ) : (
                                                  <img
                                                    src="/assets/images/uncheck.png"
                                                    className="uncheckImg"
                                                  />
                                                )}
                                              </div>
                                            </div>
                                          )
                                        )}
                                      </div>

                                      {this.state.is_trip_started > 1 ? (
                                        <div className="alertView">
                                          <h1 className="alertViewText"> </h1>
                                        </div>
                                      ) : (
                                        <>
                                          {this.state.is_trip_started > 0 ? (
                                            <>
                                              {this.state.selected_child
                                                .length > 0 ? (
                                                <div>
                                                  <h1 className="btnText">
                                                    Pick Up
                                                  </h1>
                                                </div>
                                              ) : (
                                                <div className="route-btn">
                                                  <h1 className="btnText">
                                                    Pick Up
                                                  </h1>
                                                </div>
                                              )}
                                            </>
                                          ) : (
                                            <div className="alertView">
                                              <h1 className="alertViewText"></h1>
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </>
                              );
                            } else if (item.type == "end") {
                              return (
                                <>
                                  <div
                                    className="stepBox"
                                    onPress={() => this.showAction(index)}
                                  >
                                    <div className="stepIconView">
                                      {this.state.is_open == index ? (
                                        <div className="circleBox">
                                          <img
                                            src="/assets/images/bus-stop.png"
                                            className="circleBoxImg"
                                          />
                                        </div>
                                      ) : (
                                        <img
                                          src="/assets/images/process1.png"
                                          className="activeCircle"
                                        />
                                      )}
                                      <div className="verticalLine"></div>
                                    </div>
                                    <div onPress={() => this.showAction(index)}>
                                      <div className="routeDetails">
                                        <div className="circle">
                                          <h1 className="routeNumber">
                                            {index + 1}
                                          </h1>
                                        </div>
                                        <div className="routeView">
                                          <h1 className="routeName">
                                            {item.Stop}
                                          </h1>
                                        </div>
                                      </div>
                                      <div className="blankHeight"></div>
                                    </div>
                                  </div>
                                  <div className="stepBox">
                                    <div className="verticalView"></div>
                                    <div className="route-right">

                                        <>
                                          {this.state.is_arrive > 1 && (
                                            <div className="alertView">
                                              <h1 className="alertViewText">
                                                Trip has been ended! at {item.pickup_time}
                                              </h1>
                                            </div>
                                          )}
                                        </>

                                    </div>
                                  </div>
                                </>
                              );
                            }
                          })()}
                        </>
                      ))}
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default Index;
